export default __webpack_public_path__ + "static/media/maintain.ee92f182.svg";